import React from 'react'
import { Spinner } from 'flowbite-react';

function Loader() {
  return (
    <React.Fragment>
      <div className="loader text-center mt-40">
        <button aria-label="Loading">
          <Spinner />
          <span className='pl-3'>
            Loading ...
          </span>
        </button>
      </div>
    </React.Fragment>
  )
}

export default Loader
